import { postRequest } from '../../call-center/services/restService';

const postScheduleCallback = async (hashKey, submitData) => {
    if (!hashKey || !submitData) {
        return null;
    }

    try {
        return new Promise((resolve, reject) => {
            postRequest(`/schedule/lead/${hashKey}`, submitData, resolve, reject);
        });
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
};

export default postScheduleCallback;
